import { SiteService } from '@app/_services';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FormDataHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services';
import { MetaTagsService } from '@app/_services/meta-tags.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconComponent } from '../../../icon/icon.component';
import { NgIf } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-register-componenet',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatSlideToggleModule, NgIf, IconComponent, TranslateModule]
})
export class RegisterComponent implements OnInit {

    constructor(private fb: UntypedFormBuilder,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router,
        private metaTagsService:MetaTagsService,
        private formDataHelper: FormDataHelper,
        private siteService: SiteService,
        private translate: TranslateService) { }

    @Input() bsRef: MatDialogRef<any>
    @Input() loginForm

    form = this.fb.group({
        firstname: ['', [Validators.required]],
        lastname: [''],
        mobile: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
        /* businessInfo: this.fb.group({
            name: [],
            vatCert: [],
            cr:[]
        }) */
    })

    businessUser = false;

    onToggle(evento) {
        if (evento.checked) {
            this.form.addControl('businessInfo', this.fb.group({
                name: [null, Validators.required],
                vatCert: [null, Validators.required],
                cr:[null, Validators.required]
            }));
        } else {
            this.form.removeControl('businessInfo');
        }
        this.businessUser = evento.checked;
    }

    handleFileInput(name, file: any) {

            const reader = new FileReader();
            reader.readAsDataURL(file[0])
            this.form.get(name).patchValue(file[0]);

    }

    appendImage(name, files: any) {
        this.form.get(name).patchValue(files);
    }

    remove(name, element) {
        element.value = '';
        this.form.get(name).patchValue(null);
    }

    ngOnInit(): void {
        this.metaTagsService.setMetaTags({
            title: this.siteService.siteSetting?.name || "" + "Register"
         });
    }

    submit(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        if (this.confirmPassword != this.password) {
            this.toastr.error('Passwords must match');
            return;
        }

        if (this.form.invalid) {
            this.toastr.error('Fill the required fields');
            return;
        }

        // Detect current language from multiple sources with priority order
        const routerUrl = this.router.url;
        const routerLang = routerUrl.includes('/ar/') || routerUrl.startsWith('/ar') ? 'ar' : 
                          routerUrl.includes('/en/') || routerUrl.startsWith('/en') ? 'en' : null;
        
        const currentLang = this.translate.currentLang || 
                           routerLang ||
                           localStorage.getItem('language') || 
                           document.documentElement.lang || 
                           (window.location.pathname.includes('/ar') ? 'ar' : 'en');
        
        // Add current language to form data
        const formValue = { ...this.form.value, language: currentLang };
        let formData = this.formDataHelper.ToFormData(formValue);

        this.authService.register(formData).subscribe((response: any) => {

            if(response.code == 400){
                this.toastr.error(response.msg);

            } else if(response.code == 200){
                this.toastr.success(response.msg);
                this.authService.login({email:this.form.value.email, password:this.form.value.password}).subscribe();
                this.bsRef.close();
            }

        }, (error) => {
            this.toastr.error(error.error.msg);
        })
    }

    get password() {
        return this.form.get('password').value;
    }
    get confirmPassword() {
        return this.form.get('confirmPassword').value;
    }

}
